<template>
  <CardHero>
    <MDCSlot />
  </CardHero>
</template>

<script lang="ts" setup>
import { CardHero } from '@crearis/ui'
</script>
